import { render, staticRenderFns } from "./DetailBillingDO.vue?vue&type=template&id=4e0127a4"
import script from "./DetailBillingDO.vue?vue&type=script&lang=js"
export * from "./DetailBillingDO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports